import apiErrorLg from './api-error.lg.svg';
import apiErrorSm from './api-error.sm.svg';
import defaultLg from './default.lg.svg';
import defaultSm from './default.sm.svg';
import deployLg from './deploy.lg.svg';
import deploySm from './deploy.sm.svg';
import noSearchResultsLg from './no-search-results.lg.svg';
import noSearchResultsSm from './no-search-results.sm.svg';
import notAuthorizedLg from './not-authorized.lg.svg';
import notAuthorizedSm from './not-authorized.sm.svg';
export default {
  lg: {
    apiError: apiErrorLg,
    default: defaultLg,
    deploy: deployLg,
    noSearchResults: noSearchResultsLg,
    notAuthorized: notAuthorizedLg
  },
  sm: {
    apiError: apiErrorSm,
    default: defaultSm,
    deploy: deploySm,
    noSearchResults: noSearchResultsSm,
    notAuthorized: notAuthorizedSm
  }
};